import { TransactionHistory } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for user management in the admin section.
 * @returns {Array} An array containing the route objects for user management.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.TRANSACTION_HISTORY.path,  // URL path for user management
      name: "Transaction History",  // Display name for the route
      key: adminRouteMap.TRANSACTION_HISTORY.path,  // Unique key for the route
      private: true,  // Requires authentication to access
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.TRANSACTION_HISTORY.icon,  // Icon associated with user management
      element: <TransactionHistory />,  // Component to render for user management route
    },
  ];
}
